import { Modal } from 'antd';
import { translate } from '../../lib/lang.helper';
import { useDispatch, useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';
import { selectAccount } from '../../store/auth/auth.selector';
import { CheckboxButton } from '../shared';
import { useState } from 'react';
import { updateAccountSetting } from '../../store/auth/auth.actions';

const raftColumns = [
  'Section',
  'Droppers',
  'Date seeded',
  'Planned harvest date',
  'Seed type',
  'Last assessment date',
  'Avg.Size',
  'Section group',
  'Batch seeded',
  'Days growth',
  'Inventory',
  'Section fill percentage',
  'Est amount',
  'Photo',
  'Comment',
];

interface Props {
  visible: boolean;
  onClose: () => void;
}

const RaftColumnModifyModal = ({ visible, onClose }: Props) => {
  const dispatch = useDispatch<any>();
  const lang = useSelector(selectLang);
  const accSetting = useSelector(selectAccount);
  const raftHidden = accSetting?.raft_hidden_columns ?? [];
  const raftOrder = accSetting?.raft_columns_order ?? [];

  const initialColumns = raftColumns.sort((a, b) => {
    const ai = raftOrder.indexOf(a);
    const bi = raftOrder.indexOf(b);
    return ai - bi;
  });

  const [checked, setChecked] = useState(raftHidden);
  const [tableColumns, setTableColumns] = useState(initialColumns);

  const toggleCheck = (name: string, c: boolean) => {
    if (name === 'Section') return;
    if (c) {
      setChecked(checked.filter(x => x !== name));
    } else if (!checked.includes(name)) {
      setChecked([...checked, name]);
    }
  };

  const confirmClick = async () => {
    const columns = tableColumns.filter(x => checked.includes(x));
    const data = {
      raft_hidden_columns: columns,
      raft_columns_order: tableColumns,
    };
    const r = await dispatch(updateAccountSetting(data));
    if (r !== true) {
      window.alert(r ?? 'Server error');
    } else {
      onClose();
    }
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleDrop = (index: number) => {
    return (e: React.DragEvent) => {
      const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'), 10);
      if (draggedIndex === index) return;
      const newOrder = [...tableColumns];
      const [draggedItem] = newOrder.splice(draggedIndex, 1);
      newOrder.splice(index, 0, draggedItem);
      setTableColumns(newOrder);
    };
  };

  const handleDragStart = (index: number) => {
    return (e: React.DragEvent) => {
      e.dataTransfer.setData('text/plain', String(index));
    };
  };

  return (
    <Modal
      title={translate(lang, 'Modify columns')}
      visible={visible}
      onCancel={onClose}
      onOk={confirmClick}
      closable
    >
      <div className='wrap pl-12 pr-12'>
        {tableColumns.map((x, i) => (
          <div
            key={i}
            draggable
            onDragStart={handleDragStart(i)}
            onDragOver={handleDragOver}
            onDrop={handleDrop(i)}
            className='mb-17'
          >
            <CheckboxButton
              label={translate(lang, x)}
              checked={!checked.includes(x)}
              disabled={x === 'Section'}
              onChange={e => toggleCheck(x, e.target.checked)}
            />
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default RaftColumnModifyModal;
